export default "__VITE_ASSET__DKfOZlgu__"